import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost,
} from "./_wsApiFetchData";

export async function getOverview(language, timeZone) {
  try {
    const data = await wsRequestGet(
      "/admin/SignupsOverview/overview",
      language,
      timeZone
    );
    return {
      success: true,
      data,
    };
  } catch (e) {
    console.error(`unable to get the overview: ${e}`);
    return {
      success: false,
    };
  }
}

export async function getSignupById(signupId, language, timeZone, cancelToken) {
  try {
    return await wsRequestGet(
      "/admin/signups/signup",
      language,
      timeZone,
      { signupId },
      cancelToken
    );

  } catch (e) {
    console.error(`unable to get the signup details from id ${signupId}: ${e}`);
    return {
      success: false,
    };
  }
}

export async function forceCancellation(signupId, skipExternalCancellation, language, timeZone, cancelToken) {
  try {
    const response = await wsRequestGet(
      `/admin/signups/force-cancellation/${signupId}`,
      language,
      timeZone,
      { skipExternalCancellation },
      cancelToken
    );

    return {
      success: true,
      data: response
    }
  } catch (e) {
    console.error(`unable to force cancellation from id ${signupId}: ${e}`);
    return {
      success: false
    };
  }
}

export async function changeCourt(signupId, courtId, force, language, timeZone, cancelToken) {
  try {
    const response = await wsRequestGet(
      `/admin/signups/change-court`,
      language,
      timeZone,
      { signupId, newActivityId: courtId, force },
      cancelToken
    );

    return {
      success: true,
      data: response
    }
  } catch (e) {
    console.error(`unable to force cancellation from id ${signupId}: ${e}`);
    return {
      success: false
    };
  }
}

export async function addSecretCode(signupId, secretCode, language, timeZone, cancelToken) {
  try {
    const response = await wsRequestGet(
      `/admin/signups/add-secret-code`,
      language,
      timeZone,
      { signupId, secretCode },
      cancelToken
    );

    return {
      success: true,
      data: response
    }
  } catch (e) {
    console.error(`unable to add secret code to id ${signupId}: ${e}`);
    return {
      success: false
    };
  }
}

export async function getUserSignupCount(
  userId,
  language,
  timeZone,
  cancelToken
) {
  return wsRequestGet(
    `/admin/Signups/count/${userId}`,
    language,
    timeZone,
    null,
    cancelToken
  );
}

export async function searchSignups(
  options,
  language,
  timeZone,
  cancelToken
) {
  const { filters } = options;
  const {
    orderBy,
    orderDirection,
    id,
    page,
    facilityId,
    user,
    secretCode,
    category,
    activityFrom,
    activityTo,
    signupFrom,
    signupTo,
    status,
    externalReference,
    resultsPerPage,
    courtName,
    purchaseId,
    onlyBundles
  } = filters;

  const params = {
    OrderBy: orderBy || "signupdate",
    OrderDirection: orderDirection || "desc",
    Page: page || 1,
    ResultsPerPage: resultsPerPage || 15,
    Id: id || undefined,
    FacilityId: facilityId || undefined,
    User: user || undefined,
    SecretCode: secretCode || undefined,
    Category: category ? category.replace(/\s+/g, '') : undefined,
    SignupFrom: signupFrom || undefined,
    SignupTo: signupTo || undefined,
    Status: status || undefined,
    ActivityFrom: activityFrom || undefined,
    ActivityTo: activityTo || undefined,
    ExternalReference: externalReference || undefined,
    CourtName: courtName || undefined,
    PurchaseId: purchaseId || undefined,
    OnlyBundles: onlyBundles === "true" ? true : undefined
  };
  try {
    return wsRequestGet(
      "/admin/Signups/search",
      language,
      timeZone,
      params,
      cancelToken
    );
    return {
      success: true,
      data,
    };
  } catch (e) {
    console.error(`unable to get the signups: ${e}`);
    return {
      success: false,
    };
  }
}